module.exports = __webpack_public_path__ + "fdd88b742a9f6304f05b21b86ba58d9a.woff";